import { render, staticRenderFns } from "./bgqycfcxcxhzb.vue?vue&type=template&id=00de5613&scoped=true&"
import script from "./bgqycfcxcxhzb.vue?vue&type=script&lang=js&"
export * from "./bgqycfcxcxhzb.vue?vue&type=script&lang=js&"
import style0 from "./bgqycfcxcxhzb.vue?vue&type=style&index=0&id=00de5613&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00de5613",
  null
  
)

export default component.exports